<template>
<div class="chapter">
<div class="inner_page">
<h1 class="chapter">Table of Contents</h1>
<p class="nonindent" id="c01"><a class="hlink" href="#/OEBPS/ch01.htm#c01"><em>Diary Entries</em></a></p>
<p class="nonindent" id="epi"><a class="hlink" href="#/OEBPS/epil.htm#epi"><em>Epilogue</em></a></p>
<p class="nonindent" id="his"><a class="hlink" href="#/OEBPS/his.htm#his"><em>Historical Note</em></a></p>
<p class="nonindent" id="bk"><a class="hlink" href="#/OEBPS/bk.htm"><em>Images and Documents</em></a></p>
<p class="nonindent" id="ack"><a class="hlink" href="#/OEBPS/ack.htm#ack"><em>Acknowledgments</em></a></p>
<p class="nonindent" id="ded"><a class="hlink" href="#/OEBPS/ded.htm"><em>Dedication</em></a></p>
<p class="nonindent" id="ata"><a class="hlink" href="#/OEBPS/ata.htm#ata"><em>About the Author</em></a></p>
<p class="nonindent"><a class="hlink" href="#/OEBPS/copy.htm"><em>Copyright Page</em></a></p>
<p class="nonindent" id="bm"><a class="hlink" href="#/OEBPS/bm.htm"><em>Books in the Dear Canada Series</em></a></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// toc.vue?5a455089